import { defineMessages } from '@atlassian/jira-intl';

export const messages: {
	placeholder: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	placeholder: {
		id: 'servicedesk-insight-attribute-views.group.placeholder',
		defaultMessage: 'No groups selected',
		description: 'Message displayed when there are no groups selected for an attribute',
	},
});
